import { render, staticRenderFns } from "./index-footer.vue?vue&type=template&id=2d2854d0&scoped=true&"
import script from "./index-footer.vue?vue&type=script&lang=js&"
export * from "./index-footer.vue?vue&type=script&lang=js&"
import style0 from "./index-footer.vue?vue&type=style&index=0&id=2d2854d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2854d0",
  null
  
)

export default component.exports